import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/overseasSales/clueManage'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'

const __default__ = { name: 'DcCosOFbuSalesClueEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const initForm: FbuSalesClueEditParams.RootObject = reactive({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueTypeDisabled = ref(false)

onBeforeMount(() => {
  salesClueDetail({ clueId: route.query.clueId as string }).then((res) => {
    if (res.data.remindFlag === true) {
      res.data.remindFlag = 1
    } else if (res.data.remindFlag === false) {
      res.data.remindFlag = 0
    } else {
      res.data.remindFlag = undefined
    }
    if ([1, 3].includes(res.data.clueType)) {
      clueTypeDisabled.value = true
    }
    if (res.data.visitAddress == null || res.data.visitAddress?.length === 0) {
      res.data.visitAddress = [{}]
    }
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(DetailForm, {
            ref: "detailFormRef",
            type: "edit",
            isEdit: "",
            value: dataForm,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
            clueTypeDisabled: clueTypeDisabled.value,
            resetValue: initForm
          }, null, 8, ["value", "clueTypeDisabled", "resetValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})